// frequency
export const FREQUENCY = 'frequency';

//
// must match EnumAlertFrequency.java
//
export const DAILY = 'daily';
export const HOURLY = 'hourly';
export const MINS10 = 'mins10';

export const DAILYTEXT = 'every day';
export const HOURLYTEXT = 'every hour';
export const MINS10TEXT = 'every 10 mins ';

// triggers
export const TRIGGER = 'trigger';
export const NEW = 'new results';
export const CHANGED = 'new or changed rows';

// used in AlertRef
export const NEW_RESULTS = 'new_results'; // must match EnumAlertTrigger.java
export const ALWAYS = 'always'; // must match EnumAlertTrigger.java
